import { Box, Card, Grid, Icon, Typography } from "@mui/material";
import { CustomButton } from "components/roundedbutton/CustomButton";
import HeaderOuBannerDependendoDaInterpretacaoH1 from "layout/header-ou-banner-dependendo-da-interpretacao-h1/HeaderOuBannerDependendoDaInterpretacaoH1";
import ConfiguracaoIcon from "pages/Venda/ConfiguracaoIcon";
import CustomDoubleLeft from "pages/Venda/CustomDoubleLeft";
import CustomPercent from "pages/Venda/CustomPercent";
import CustomPoliticaVenda from "pages/Venda/CustomPoliticaVenda";
import CustomTableDollar from "pages/Venda/CustomTableDollar";
import CustomUserSettings from "pages/Venda/CustomUserSettings";
import { memo } from "react";
import { useNavigate } from "react-router-dom";
import { useAppSelector } from "redux/hooks";
import { ConfiguracoesTelas, ConfiguracoesTitle } from "./Configuracoes.model";

import MoneyTriple from "components/Icons/MoneyTriple";
import { customColors, theme } from "theme";

type TConfiguracoesDefaultBodyProps = {
  hasAcesso: boolean;
  handleActiveScreen: (screen: ConfiguracoesTelas, isEnabled: boolean) => void;
};

const ConfiguracoesDefaultBody = (props: TConfiguracoesDefaultBodyProps) => {
  const navigate = useNavigate();
  const { caixaAberto } = useAppSelector((e) => e.caixa.caixaAtual);

  return (
    <>
      <Box id="configuracoes-body">
        <HeaderOuBannerDependendoDaInterpretacaoH1
          id="configuracoes"
          customIcon={
            <ConfiguracaoIcon
              fontSize={"50px"}
              color={theme.palette.text.primary}
              id="configurar-desconto-icon"
            />
          }
          label="Configurações"
        />

        <Grid
          container
          spacing={5}
          sx={{ display: "flex", justifyContent: "center" }}
        >
          <Grid
            item
            xl={4}
            md={6}
            sm={6}
            sx={{ justifyContent: "center", marginTop: "50px" }}
          >
            <Card
              onClick={() =>
                props.handleActiveScreen(
                  ConfiguracoesTelas.CONFIGURAR_DESCONTOS_ACRESCIMOS,
                  true
                )
              }
              variant="outlined"
              id={
                props.hasAcesso
                  ? "card_configurar_desconto_caixa_habilitado"
                  : "card_configurar_desconto_caixa_desabilitado"
              }
              className="card"
              sx={{
                borderWidth: props.hasAcesso ? "2px" : 0,
                borderColor: props.hasAcesso
                  ? theme.palette.primary.main
                  : theme.palette.text.primary,
                display: "flex",
                flexDirection: "column",
                borderRadius: "20px",
                boxShadow: "5px 5px 10px 0 rgba(0,0,0,0.15)",
                cursor: props.hasAcesso ? "pointer" : "auto",
                bgcolor: props.hasAcesso ? "" : customColors.cinzaClaro,
              }}
            >
              <CustomPercent
                id="custom_percent_icon_configuracoes"
                color={
                  props.hasAcesso
                    ? theme.palette.text.primary
                    : theme.palette.text.disabled
                }
                fontSize="60px"
                style={{ marginBottom: "10px" }}
              />
              <Typography
                id="configuracoes_desconto_title"
                sx={{
                  fontSize: "30px",
                  color: props.hasAcesso
                    ? theme.palette.text.primary
                    : theme.palette.text.disabled,
                  textAlign: "center",
                  padding: "0 10px 0 10px",
                  userSelect: "none",
                }}
              >
                {ConfiguracoesTitle.DESCONTOS_ACRESCIMOS}
              </Typography>
            </Card>
          </Grid>

          <Grid
            item
            xl={4}
            md={6}
            sm={6}
            sx={{ justifyContent: "center", marginTop: "50px" }}
          >
            <Card
              onClick={() =>
                props.handleActiveScreen(
                  ConfiguracoesTelas.CONFIGURAR_MOVIMENTACOES_FISCAIS,
                  true
                )
              }
              variant="outlined"
              id={
                props.hasAcesso
                  ? "card_configurar_desconto_caixa_habilitado"
                  : "card_configurar_desconto_caixa_desabilitado"
              }
              className="card"
              sx={{
                borderWidth: props.hasAcesso ? "2px" : 0,
                borderColor: props.hasAcesso
                  ? theme.palette.primary.main
                  : theme.palette.text.primary,
                display: "flex",
                flexDirection: "column",
                borderRadius: "20px",
                boxShadow: "5px 5px 10px 0 rgba(0,0,0,0.15)",
                cursor: props.hasAcesso ? "pointer" : "auto",
                bgcolor: props.hasAcesso ? "" : customColors.cinzaClaro,
              }}
            >
              <CustomUserSettings
                id="custom_hand_holding_dollar_icon_configuracoes"
                color={
                  props.hasAcesso
                    ? theme.palette.text.primary
                    : theme.palette.text.disabled
                }
                fontSize="60px"
                style={{ marginBottom: "5px" }}
              />
              <Typography
                id="configuracoes_movimentacoes_fiscais_title"
                sx={{
                  fontSize: "30px",
                  color: props.hasAcesso
                    ? theme.palette.text.primary
                    : theme.palette.text.disabled,
                  textAlign: "center",
                  padding: "0 10px 0 10px",
                  lineHeight: "30px",
                  userSelect: "none",
                }}
              >
                {ConfiguracoesTitle.MOVIMENTACOES_FISCAIS}
              </Typography>
            </Card>
          </Grid>

          <Grid
            item
            xl={4}
            md={6}
            sm={6}
            sx={{ justifyContent: "center", marginTop: "50px" }}
          >
            <Card
              onClick={() =>
                props.handleActiveScreen(
                  ConfiguracoesTelas.CONFIGURAR_COBRANCA_TABELAS_PRECO_E_DEPOSITO,
                  true
                )
              }
              variant="outlined"
              id={
                props.hasAcesso
                  ? "card_configurar_desconto_caixa_habilitado"
                  : "card_configurar_desconto_caixa_desabilitado"
              }
              className="card"
              sx={{
                borderWidth: props.hasAcesso ? "2px" : 0,
                borderColor: props.hasAcesso
                  ? theme.palette.primary.main
                  : theme.palette.text.primary,
                display: "flex",
                flexDirection: "column",
                borderRadius: "20px",
                boxShadow: "5px 5px 10px 0 rgba(0,0,0,0.15)",
                cursor: props.hasAcesso ? "pointer" : "auto",
                bgcolor: props.hasAcesso ? "" : customColors.cinzaClaro,
              }}
            >
              <CustomTableDollar
                id="custom_table_dollar_icon_configuracoes"
                color={
                  props.hasAcesso
                    ? theme.palette.text.primary
                    : theme.palette.text.disabled
                }
                fontSize="60px"
                style={{ marginBottom: "5px" }}
              />
              <Typography
                id="configuracoes_tabela_preco_deposito_title"
                sx={{
                  fontSize: "30px",
                  color: props.hasAcesso
                    ? theme.palette.text.primary
                    : theme.palette.text.disabled,
                  textAlign: "center",
                  padding: "0 10px 0 10px",
                  lineHeight: "30px",
                  userSelect: "none",
                }}
              >
                {ConfiguracoesTitle.COBRANCA_TABELAS_PRECO_E_DEPOSITO}
              </Typography>
            </Card>
          </Grid>

          <Grid
            item
            xl={4}
            md={6}
            sm={6}
            sx={{ justifyContent: "center", marginTop: "50px" }}
          >
            <Card
              onClick={() =>
                props.handleActiveScreen(
                  ConfiguracoesTelas.CONFIGURAR_POLITICA_DEVOLUCAO,
                  true
                )
              }
              variant="outlined"
              id={
                props.hasAcesso
                  ? "card_configurar_desconto_caixa_habilitado"
                  : "card_configurar_desconto_caixa_desabilitado"
              }
              className="card"
              sx={{
                borderWidth: props.hasAcesso ? "2px" : 0,
                borderColor: props.hasAcesso
                  ? theme.palette.primary.main
                  : theme.palette.text.primary,
                display: "flex",
                flexDirection: "column",

                borderRadius: "20px",
                boxShadow: "5px 5px 10px 0 rgba(0,0,0,0.15)",
                cursor: props.hasAcesso ? "pointer" : "auto",
                bgcolor: props.hasAcesso ? "" : customColors.cinzaClaro,
              }}
            >
              <CustomDoubleLeft
                id="custom_double_left_icon_configuracoes"
                color={
                  props.hasAcesso
                    ? theme.palette.text.primary
                    : theme.palette.text.disabled
                }
                fontSize="60px"
                style={{ marginBottom: "5px" }}
              />
              <Typography
                id="configuracoes_politica_devolucao_icon"
                sx={{
                  fontSize: "30px",
                  color: props.hasAcesso
                    ? theme.palette.text.primary
                    : theme.palette.text.disabled,
                  textAlign: "center",
                  padding: "0 10px 0 10px",
                  lineHeight: "30px",
                  userSelect: "none",
                }}
              >
                {ConfiguracoesTitle.POLITICA_DEVOLUCAO}
              </Typography>
            </Card>
          </Grid>

          <Grid
            item
            xl={4}
            md={6}
            sm={6}
            sx={{ justifyContent: "center", marginTop: "50px" }}
          >
            <Card
              onClick={() =>
                props.handleActiveScreen(
                  ConfiguracoesTelas.CONFIGURAR_POLITICA_VENDA,
                  true
                )
              }
              variant="outlined"
              id={
                props.hasAcesso
                  ? "card_configurar_desconto_caixa_habilitado"
                  : "card_configurar_desconto_caixa_desabilitado"
              }
              className="card"
              sx={{
                borderWidth: props.hasAcesso ? "2px" : 0,
                borderColor: props.hasAcesso
                  ? theme.palette.primary.main
                  : theme.palette.text.primary,
                display: "flex",
                flexDirection: "column",
                borderRadius: "20px",
                boxShadow: "5px 5px 10px 0 rgba(0,0,0,0.15)",
                cursor: props.hasAcesso ? "pointer" : "auto",
                bgcolor: props.hasAcesso ? "" : customColors.cinzaClaro,
              }}
            >
              <CustomPoliticaVenda
                id="custom_double_left_icon_configuracoes"
                color={
                  props.hasAcesso
                    ? theme.palette.text.primary
                    : theme.palette.text.disabled
                }
                fontSize="60px"
                style={{ marginBottom: "5px" }}
              />
              <Typography
                id="configuracoes_politica_devolucao_icon"
                sx={{
                  fontSize: "30px",
                  color: props.hasAcesso
                    ? theme.palette.text.primary
                    : theme.palette.text.disabled,
                  textAlign: "center",
                  padding: "0 10px 0 10px",
                  lineHeight: "30px",
                  userSelect: "none",
                }}
              >
                {ConfiguracoesTitle.CONFIGURACAO_POLITICA_VENDA}
              </Typography>
            </Card>
          </Grid>

          <Grid
            item
            xl={4}
            md={6}
            sm={6}
            sx={{ justifyContent: "center", marginTop: "50px" }}
          >
            <Card
              onClick={() =>
                props.handleActiveScreen(
                  ConfiguracoesTelas.CONFIGURAR_CAIXA,
                  true
                )
              }
              variant="outlined"
              id={"configurar-caixa-card"}
              className="card"
              sx={{
                borderWidth: props.hasAcesso ? "2px" : 0,
                borderColor: props.hasAcesso
                  ? theme.palette.primary.main
                  : theme.palette.text.primary,
                display: "flex",
                flexDirection: "column",
                borderRadius: "20px",
                boxShadow: "5px 5px 10px 0 rgba(0,0,0,0.15)",
                cursor: props.hasAcesso ? "pointer" : "auto",
                bgcolor: props.hasAcesso ? "" : customColors.cinzaClaro,
              }}
            >
              <MoneyTriple
                id="configurar-caixa-icon"
                color={
                  props.hasAcesso
                    ? theme.palette.text.primary
                    : theme.palette.text.disabled
                }
                fontSize="50px"
                style={{ marginBottom: "5px" }}
              />
              <Typography
                id="configurar-caixa-label"
                sx={{
                  fontSize: "30px",
                  color: props.hasAcesso
                    ? theme.palette.text.primary
                    : theme.palette.text.disabled,
                  textAlign: "center",
                  padding: "0 10px 0 10px",
                  lineHeight: "30px",
                  userSelect: "none",
                }}
              >
                {ConfiguracoesTitle.CONFIGURACAO_CAIXA}
              </Typography>
            </Card>
          </Grid>
        </Grid>

        <Box
          sx={{
            display: "flex",
            justifyContent: "right",
            alignItems: "flex-end",
            marginBottom: "20px",
            height: "40%",
            marginTop: "20px",
          }}
        >
          <CustomButton
            sx={{ marginLeft: "10px", minWidth: "80px" }}
            id="vendas_irpdv_btn"
            onClick={() => {
              navigate("/registra-venda");
            }}
            variant="contained"
            color="success"
            disabled={!caixaAberto ? true : false}
            startIcon={<Icon className="fa-solid fa-arrow-right" />}
          >
            Ir para o PDV
          </CustomButton>
        </Box>
      </Box>
    </>
  );
};

export default memo(ConfiguracoesDefaultBody);
